/** Стабильный URL заглушки аватара (файл в mob_app/img/no_logo.jpg). */
export const DEFAULT_AVATAR_URL = '/mob_app/img/no_logo.jpg';
